import gbAntSectionTitle from "./src/gb-ant-section-title.vue";
const gbAntSectionTitleCompenet = function(Vue) {
  Vue.component(gbAntSectionTitle.name, gbAntSectionTitle);
};
export default gbAntSectionTitleCompenet;
